function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_8173_106279)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.2917 36.4167C28.6055 36.4167 27.9392 36.3639 27.2927 36.2584C26.6462 36.1528 26.0194 35.9945 25.4125 35.7834L3.16666 27.6688L3.95832 25.4125L14.8833 29.4105L17.6146 22.3646L11.9542 16.4667C11.2417 15.7278 10.958 14.8504 11.1031 13.8344C11.2483 12.8184 11.7694 12.0466 12.6667 11.5188L18.1687 8.35212C18.6174 8.08823 19.0726 7.9365 19.5344 7.89692C19.9962 7.85733 20.4514 7.9299 20.9 8.11462C21.3486 8.27296 21.7378 8.52365 22.0677 8.86671C22.3976 9.20976 22.6417 9.61879 22.8 10.0938L23.3146 11.7959C23.6576 12.9306 24.2184 13.9334 24.9969 14.8042C25.7753 15.675 26.7055 16.3348 27.7875 16.7834L28.6187 14.25L30.875 14.9625L29.0937 20.425C27.141 20.1084 25.4125 19.3431 23.9083 18.1292C22.4042 16.9153 21.2958 15.4112 20.5833 13.6167L16.5854 15.9125L21.375 21.375L17.8521 30.4792L22.7604 32.2605L26.0854 22.0875C26.4549 22.2195 26.8243 22.3382 27.1937 22.4438C27.5632 22.5493 27.9458 22.6417 28.3417 22.7209L24.9771 33.0917L26.2042 33.5271C26.6792 33.6855 27.1739 33.8108 27.6885 33.9032C28.2031 33.9955 28.7375 34.0417 29.2917 34.0417C29.9778 34.0417 30.6309 33.9757 31.251 33.8438C31.8712 33.7118 32.4715 33.5139 33.0521 33.25L34.8333 35.0313C33.9889 35.4799 33.1049 35.823 32.1812 36.0605C31.2576 36.298 30.2944 36.4167 29.2917 36.4167ZM26.125 10.2917C25.2542 10.2917 24.5087 9.98164 23.8885 9.3615C23.2684 8.74136 22.9583 7.99587 22.9583 7.12504C22.9583 6.25421 23.2684 5.50872 23.8885 4.88858C24.5087 4.26844 25.2542 3.95837 26.125 3.95837C26.9958 3.95837 27.7413 4.26844 28.3614 4.88858C28.9816 5.50872 29.2917 6.25421 29.2917 7.12504C29.2917 7.99587 28.9816 8.74136 28.3614 9.3615C27.7413 9.98164 26.9958 10.2917 26.125 10.2917Z"
}));

function SvgSkiing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8173_106279",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiing);
export default __webpack_public_path__ + "static/media/skiing.59577ae9.svg";
export { ForwardRef as ReactComponent };